import { EntityModel } from '@/interfaces'
import { ALL_CMS_QUERY, CREATE_CMS_MUTATION, DELETE_CMS_MUTATION, FORCE_DELETE_CMS_MUTATION, SINGLE_CMS_QUERY, UPDATE_CMS_MUTATION } from './graphql'
import cmsPageEntity from '@/entities/cmsPage/entity'
import cmsCategoryEntity from '@/entities/cmsCategory/entity'
import cmsConfigEntity from '@/entities/cmsConfig/entity'

const tenantCmsModel: EntityModel = {
  name: 'cms',
  namePlural: 'cms',
  uniqueName: 'tenantCms',
  uniqueNamePlural: 'tenantCms',
  path: 'config/tenant/cms',
  baseUrl: '/config/tenant/cms',
  translationPrefix: 'entities:tenantCms.',
  getDisplayName: (values: any) => {
    return 'Tenant CMS'
  },
  gql: {
    getAll: ALL_CMS_QUERY,
    getSingle: SINGLE_CMS_QUERY,
    create: CREATE_CMS_MUTATION,
    update: UPDATE_CMS_MUTATION,
    delete: DELETE_CMS_MUTATION,
    forceDelete: FORCE_DELETE_CMS_MUTATION,
  },
  attributes: {
    homepage: {
      name: 'homepage',
      label: 'entities:tenantCms.attributes.homepage.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsPageEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    categories: {
      name: 'categories',
      label: 'entities:tenantCms.attributes.categories.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return cmsCategoryEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    pages: {
      name: 'pages',
      label: 'entities:tenantCms.attributes.pages.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return cmsPageEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    errorPage404: {
      name: 'errorPage404',
      label: 'entities:tenantCms.attributes.errorPage404.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsPageEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    errorPage500: {
      name: 'errorPage500',
      label: 'entities:tenantCms.attributes.errorPage500.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsPageEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    config: {
      name: 'config',
      label: 'entities:tenantCms.attributes.config.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsConfigEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default tenantCmsModel
